import { RouterProvider, createBrowserRouter } from "react-router-dom";
import RootLayout from "./components/RootLayout";
import HomePage from "./pages/Home";
import AboutUs from "./pages/About/About";
import RumiRegionsGrid from "./pages/shop/RumiRegionGrid";
import ProductGallery from "./pages/products/ProductGallery";
import DetailPage from "./pages/DetailPage/DetailPage";
import News from "./pages/NewsPage/NewsPage";
import DetailNews from "./pages/NewsPage/DetailNews";
import LuckyGame from "./pages/LuckyWheel/LuckyGame";
import PrizeQuantityForm from "./pages/LuckyWheel/PrizeQuantityForm";

const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: "products", element: <ProductGallery /> },
      { path: "products/:productId", element: <DetailPage /> },
      { path: "news", element: <News /> },
      { path: "news/:id", element: <DetailNews /> },
      { path: "about", element: <AboutUs /> },
      { path: "shop", element: <RumiRegionsGrid /> },
      { path: "lucky-wheel", element: <LuckyGame /> },
      { path: "prize-quantity", element: <PrizeQuantityForm /> },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
